import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import DashboardSidebar from '../components/dashboard/DashboardSidebar';
import AnalyticsPage from './AnalyticsPage';
import BookingsPage from './BookingsPage';
import MessagesPage from './MessagesPage';
import GuestsPage from './GuestsPage';
import SettingsPage from './SettingsPage';
import PageWrapper from '../components/layout/PageWrapper';
import EarningsOverview from '../components/dashboard/EarningsOverview';
import BookingsWidget from '../components/dashboard/BookingsWidget';
import { MessagesWidget } from '../components/dashboard/MessagesWidget';
import ReviewsWidget from '../components/dashboard/ReviewsWidget';

const ManagerDashboard: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex">
      <DashboardSidebar />
      
      <PageWrapper fullWidth className="flex-1">
        <Routes>
          <Route path="/" element={
            <motion.div 
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5 }}
              className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"
            >
              <div className="flex items-center justify-between mb-8">
                <div>
                  <h1 className="text-2xl font-semibold text-gray-900">Welcome back, Alex!</h1>
                  <p className="text-gray-500 mt-1">Here's what's happening with your properties today.</p>
                </div>
                <button className="bg-airbnb-red hover:bg-red-600 text-white px-6 py-2.5 rounded-xl font-medium transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 shadow-sm">
                  Add New Property
                </button>
              </div>

              <EarningsOverview />

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mt-8">
                <motion.div
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <BookingsWidget />
                </motion.div>

                <motion.div
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.5, delay: 0.3 }}
                >
                  <MessagesWidget />
                </motion.div>
              </div>

              <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                className="mt-8"
              >
                <ReviewsWidget />
              </motion.div>
            </motion.div>
          } />
          <Route path="analytics" element={<AnalyticsPage />} />
          <Route path="bookings" element={<BookingsPage />} />
          <Route path="messages" element={<MessagesPage />} />
          <Route path="guests" element={<GuestsPage />} />
          <Route path="settings" element={<SettingsPage />} />
        </Routes>
      </PageWrapper>
    </div>
  );
};

export default ManagerDashboard;